import React, { createContext, useReducer } from 'react'
import { QuestionsReducer } from '../Reducers/QuestionsReducer'

export const initialStateQuestionsReducer = {
  questions: [],
  additionalQuestions: [],
  globalStyle: {
    questions: {},
    answers: {},
  },
}

const StoreQuestions = ({ children }) => {
  const [state, dispatch] = useReducer(
    QuestionsReducer,
    initialStateQuestionsReducer,
  )
  return (
    <ContextQuestions.Provider value={[state, dispatch]}>
      {children}
    </ContextQuestions.Provider>
  )
}

export const ContextQuestions = createContext(initialStateQuestionsReducer)
export default StoreQuestions
